var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image zis-4by3 img-zoom-container"},[(_vm.showZoom)?_c('div',{staticClass:"img-zoom-lens",attrs:{"id":"img-zoom-lens"}}):_vm._e(),_c('img',{attrs:{"id":"myimage","src":_vm.url,"alt":""},on:{"click":_vm.changeZoomState}}),(_vm.showZoom)?_c('div',{staticClass:"img-zoom-result",style:({
              backgroundImage: 'url(' + _vm.url + ')',
              backgroundPosition: _vm.backgroundPosition,
              visibility: _vm.displayZoom ? 'visible' : 'hidden'
            }),attrs:{"id":"myresult"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }